<template>
  <Modal
    v-model="show"
    :closable="false"
    footer-hide
    width="70"
    >
    <div
      v-if="journal"
      >
      <Row
        >
        <Col span="24">
          <Input
            v-model="journal.text"
            type="textarea"
            :autosize="{minRows: 4,maxRows: 8}"
            placeholder="原稿を入力..." />
        </Col>
      </Row>
      <Row>
        <Col span="18">
          <template v-if="workspace.channel_id == 'ex' && Math.max(...journal.text.split('\n').map(i => {var m = i.match(/^【(.*?)】/); return (m ? m[1].length : 0) + i.replace(/^【(.*?)】/, '').length})) > 40">
            <p class="red">
              ※ 1行あたりの文字数超過のため、スクロール表示します（冒頭の【】を除く）
            </p>
          </template>
          <template v-if="journal.text && (journal.text.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g).length != journal.text.length)">
            <p class="red">
              ※ 表示できない文字が含まれています
            </p>
          </template>
        </Col>
        <Col span="6" style="float: right">
          <span
            :class="{'red': journal.text.length > 26}"
            style="float: right;"
            >
            {{ journal.text.length }}文字
          </span>
        </Col>
      </Row>
      <Row style="padding-top: 0.5em">
        <Col span="24">
          <h4>変更履歴</h4>
          <div style="min-height: 50px; max-height: 200px; overflow-y: scroll">
            <Timeline>
            <TimelineItem v-for="rev in revisions" :key="rev.created_at">
                <p class="time">
                  {{ rev.created_at | formatDate('MM-DD HH:mm') }}
                  ({{ rev.created_at | fromNow }})
                </p>
                <p class="content" style="white-space: pre-line">{{ rev.text }}</p>
              </TimelineItem>
            </Timeline>
          </div>
        </Col>
      </Row>
      <Row style="margin: 24px 0 0">
        <Col span=24>
          <Button type="text" @click="show = false">キャンセル</Button>
          <Button
            type="primary"
            style="float: right"
            @click="execute"
            :disabled="journal.text && (journal.text.length != journal.text.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g).length)"
          >更新する</Button>
        </Col>
      </Row>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { fromNow, formatDate } from '../../utils'

export default {
  data() {
    return {
      show: false,
      journal: null
    }
  },
  watch: {
    target(val) {
      if (val) {
        this.show = true
        this.journal = val
      } else {
        this.show = false
        this.journal = null
      }
    },
    show(val) {
      if (!val) {
        this.unsetTarget()
      }
    },
  },
  filters: {
    fromNow, formatDate
  },
  computed: {
    ...mapGetters({
      target: 'dashboard/journalEditModalTarget'
    }),
    ...mapGetters([
      'getWorkspace',
    ]),
    page() {
      return this.$route.params
    },
    workspace() {
      return this.getWorkspace(this.page)
    },
    revisions() {
      return this.journal.revisions.sort((i, j) => j.created_at - i.created_at)
    }
  },
  methods: {
    ...mapActions({
      unsetTarget: 'dashboard/unsetJournalEditModalTarget',
      updateJournal: 'updateJournal'
    }),
    async execute() {
      await this.updateJournal({
        ...this.page, journal: this.journal
      })
      this.show = false
    }
  }
}
</script>
